import { render, staticRenderFns } from "./AsistenciasForm.vue?vue&type=template&id=8542ecf8&scoped=true"
import script from "./AsistenciasForm.vue?vue&type=script&lang=js"
export * from "./AsistenciasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8542ecf8",
  null
  
)

export default component.exports